import React, { useEffect, useState } from "react";
import authLogo from "../../../assets/auth_logo.png";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom"; // Adjust this import path as necessary
import {
  usePostLoginMutation,
  usePostResendOTPMutation,
  usePostVerifyOTPMutation,
} from "../../../rtk-query/slices/auth/authSlice";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
// Import custom styles if needed

function VerifyTokenCard() {
  const navigate = useNavigate();
  const [postVerifyOTP, { isLoading }] = usePostVerifyOTPMutation(); // Adjust as necessary for your API slice
  const [postResendOTP, { isLoading: isResetOTPLoading }] =
    usePostResendOTPMutation(); // Adjust as necessary for your API slice
  const {
    refetch,
    fetching: isUserDataFetching,
    isLoading: isUserDataLoading,
  } = useGetUserProfileQuery();

  const [timer, setTimer] = useState(0); // State for countdown timer

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (
      !localStorage.getItem("DODUserEmailToVerifyNext") ||
      !localStorage.getItem("DODUserEmailToVerify")
    ) {
      navigate("/forgot-password");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      otp: "", // Initial value for OTP
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .length(6, "OTP must be exactly 6 digits")
        .matches(/^\d+$/, "OTP must be a number")
        .required("OTP is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // navigate("/onboarding");
        const email = localStorage.getItem("DODUserEmailToVerify");

        const response = await postVerifyOTP({ otp: values.otp, email: email });
        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          const userDataResponse = await refetch();
          const nextScreen = await localStorage.getItem(
            "DODUserEmailToVerifyNext"
          );
          if (nextScreen === "reset-password") {
            localStorage.setItem("DODUserEmailToResetPassword", email);
            navigate(`/${nextScreen}`);
          } else {
            if (userDataResponse?.data?.data?.supplier?.on_boardings < 4) {
              navigate("/onboarding"); // Clear the stored user email
            } else {
              navigate("/"); // Clear the stored user email
            } // Navigate to the next page on success
            localStorage.removeItem("DODUserEmailToVerifyNext"); // Clear the stored user email
            localStorage.removeItem("DODUserEmailToVerify");
          }

          // Clear the login token
        } else if (response?.error) {
          toast.error(response?.error?.data.message, {
            position: "top-center",
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.error("An unexpected error occurred. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleSubmitResendOTP = async () => {
    try {
      // navigate("/onboarding");

      const email = localStorage.getItem("DODUserEmailToVerify");

      const response = await postResendOTP({ email: email });
      if (response?.data?.status) {
        setTimer(60);
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      } else if (response?.error) {
        toast.error(response?.error?.data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      // setSubmitting(false);
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-card-header d-flex align-items-center justify-content-center">
        <img src={authLogo} alt="logo" width={170} height={37} />
      </div>
      <div className="auth-card-body">
        <h1 className="auth-card-heading mb-2">Verify your account</h1>
        <p className="auth-card-description">
          Enter the OTP code sent to your email.
        </p>
        <form onSubmit={formik.handleSubmit} className="auth-card-form mt-3">
          {/* OTP input field */}
          <div className="auth-card-form-group d-flex flex-column align-items-center gap-2 mb-2 mt-4">
            <OtpInput
              value={formik.values.otp}
              onChange={(otp) => formik.setFieldValue("otp", otp)}
              numInputs={6} // Number of OTP digits
              renderSeparator={<span className="ps-1 pe-1">-</span>}
              isDisabled={isLoading}
              inputStyle="ob-pi-otp-input"
              renderInput={(props) => <input {...props} />}
              hasErrored={formik.touched.otp && !!formik.errors.otp}
            />
            {formik.touched.otp && formik.errors.otp ? (
              <div className="invalid-feedback d-block">
                {formik.errors.otp}
              </div>
            ) : null}
          </div>

          {/* Submit button */}
          <button
            type="submit"
            disabled={isLoading || formik.isSubmitting}
            className="w-100 auth-login-btn mt-4 mb-4"
          >
            Verify Account{" "}
            {(isLoading || isUserDataLoading || isUserDataFetching) && (
              <Spinner size="sm" />
            )}
          </button>
        </form>
      </div>
      <div className="auth-card-footer pt-3 pb-3">
        <p>
          Do not receive OTP yet?{" "}
          <span
            onClick={(e) => {
              e.preventDefault();
              if (!isResetOTPLoading && timer === 0) {
                handleSubmitResendOTP();
              }
            }}
            className="cursor-pointer"
            style={{
              cursor: "pointer"
            }}
          >
            Resend {timer > 0 && `after (${timer}s)`}{" "}
            {isResetOTPLoading && <Spinner size="sm" />}
          </span>
        </p>
      </div>
    </div>
  );
}

export default VerifyTokenCard;
